var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSerialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61972_12776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.05469 0H8.94019V1.3208H7.05469V0Z",
    fill: "#5B6673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.744 6.77539H4.25C4.33679 7.20618 4.71814 7.53162 5.17419 7.53162H10.8201C11.276 7.53162 11.6573 7.20618 11.744 6.77539Z",
    fill: "#5B6673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2891 8.46875H13.1744V9.78955H11.2891V8.46875Z",
    fill: "#5B6673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82031 8.46875H4.70581V9.78955H2.82031V8.46875Z",
    fill: "#5B6673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7656 0.942749C11.7656 0.422852 11.3428 0 10.823 0H9.88025V1.78955C9.88025 2.04846 9.67029 2.2583 9.4115 2.2583H6.5885C6.32959 2.2583 6.11975 2.04846 6.11975 1.78955V0H5.17712C4.65723 0 4.23438 0.422852 4.23438 0.942749V5.83752H11.7656V0.942749Z",
    fill: "#5B6673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.939819 16.0004H6.58557C7.04163 16.0004 7.42297 15.6749 7.50964 15.2441H0.015625C0.102417 15.6749 0.483765 16.0004 0.939819 16.0004Z",
    fill: "#5B6673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0574 8.46875H14.1146V10.2583C14.1146 10.5172 13.9047 10.7271 13.6459 10.7271H10.823C10.5641 10.7271 10.3542 10.5172 10.3542 10.2583V8.46875H9.4115C8.8916 8.46875 8.46875 8.8916 8.46875 9.4115V14.3063H16V9.4115C16 8.8916 15.5771 8.46875 15.0574 8.46875Z",
    fill: "#5B6673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40845 16.0004H15.0543C15.5103 16.0004 15.8916 15.6749 15.9783 15.2441H8.48438C8.57104 15.6749 8.95239 16.0004 9.40845 16.0004Z",
    fill: "#5B6673"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5885 8.46875H5.64587V10.2583C5.64587 10.5172 5.43591 10.7271 5.17712 10.7271H2.35413C2.09534 10.7271 1.88538 10.5172 1.88538 10.2583V8.46875H0.942749C0.422852 8.46875 0 8.8916 0 9.4115V14.3063H7.53125V9.4115C7.53125 8.8916 7.1084 8.46875 6.5885 8.46875Z",
    fill: "#5B6673"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61972_12776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerialIcon);
export default __webpack_public_path__ + "static/media/serial-icon.c6f1d1b231e40b4bf07c666746a3d999.svg";
export { ForwardRef as ReactComponent };